export const initSentry = () => {
  window.ikea?.sentry?.register(
    "6102214",
    "536d28e01f1c4d9982937895f7557e02",
    "design-your-home",
    "release-version",
    1.0, // 100% sample rate
    [/\/[a-z0-9]{2}\/[a-z0-9]{2}\/home-design\//] // Paths to register for errors in
  );
};

const sentryClient = {
  init: initSentry,
};

export default sentryClient;
